export const bundesligaFinale2026Hannover = {
  "id": "bundesliga-finale-2026-hannover",
  "title": "Bundesliga Finale am 13.06. in Hannover",
  "slug": "bundesliga-finale-2026-hannover",
  "publishedAt": "2026-06-04T09:00:00Z",
  "author": "Rugby Bundesliga Redaktion",
  "language": "de",
  "readTime": "3 min",
  "tags": [
    "Rugby",
    "Bundesliga",
    "Finale",
    "Deutsche Meisterschaft",
    "Hannover",
    "Livestream",
    "SC 1880 Frankfurt",
    "SC Neuenheim"
  ],
  "excerpt": "Am 13. Juni 2026 richtet sich der Blick der deutschen Rugbyszene nach Hannover. Im Beekestadion Ricklingen treffen mit dem SC 1880 Frankfurt und dem SC Neuenheim die beiden Finalisten der Bundesliga Saison 2025/26 aufeinander und spielen um die Deutsche Meisterschaft.",
  "img": "/images/bundesliga-finale-2026-hannover-beekestadion.jpeg",
  "blocks": [
    {
      "type": "paragraph",
      "content": "Am 13. Juni 2026 richtet sich der Blick der deutschen Rugbyszene nach Hannover. Im Beekestadion Ricklingen treffen mit dem SC 1880 Frankfurt und dem SC Neuenheim die beiden Finalisten der Bundesliga Saison 2025/26 aufeinander und spielen um die Deutsche Meisterschaft."
    },
    {
      "type": "paragraph",
      "content": "Der Finaltag beginnt jedoch bereits deutlich vor dem Ankick. Um 12:00 Uhr kommt zunächst der Rugby Bundesliga Ausschuss zu seiner Sitzung zusammen, bevor wenige Stunden später das sportliche Highlight der Saison folgt. Die Verantwortlichen wollen den Tag bewusst nutzen, um sowohl wichtige Weichenstellungen für die Zukunft der Liga vorzunehmen als auch die aktuelle Saison mit einem würdigen Finale abzuschließen."
    },
    {
      "type": "paragraph",
      "content": "Eine besondere Bedeutung kommt dabei dem Livestream des Endspiels zu. Bereits ab 14:15 Uhr startet die Vorberichterstattung auf dem offiziellen YouTube Kanal der Rugby Bundesliga."
    },
    {
      "type": "list",
      "items": [
        { "content": "Offizieller YouTube Kanal der Rugby Bundesliga", "url": "https://www.youtube.com/@RDBundesliga" }
      ],
      "ordered": false
    },
    {
      "type": "paragraph",
      "content": "Der Stream wird erstmals vollständig durch den Rugby Bundesliga Ausschuss organisiert und produziert und soll als Pilotprojekt für die kommende Saison dienen. Federführend verantwortlich für die Umsetzung ist Tobias Bleckmann, der gemeinsam mit seinem Team die technische und organisatorische Durchführung der Übertragung koordiniert."
    },
    {
      "type": "paragraph",
      "content": "Dabei geht es nicht nur darum, das Finale live zu übertragen. Vielmehr soll die Übertragung zeigen, wie ein zentral organisiertes Bundesligastreaming künftig aussehen kann. Die Erfahrungen aus Hannover werden direkt in die Planungen für die Saison 2026/27 einfließen, in der die Rugby Bundesliga ihre mediale Präsenz weiter ausbauen möchte. Das Finale dient damit zugleich als Testlauf und Startschuss für ein bundesweit koordiniertes Streamingkonzept, das künftig bei Spielen der Rugby Bundesliga zum Einsatz kommen soll."
    },
    {
      "type": "paragraph",
      "content": "Besonderen Wert legt das Produktionsteam auf eine nachvollziehbare und informative Berichterstattung. Zuschauerinnen und Zuschauer sollen nicht nur das Spielgeschehen verfolgen können, sondern auch die Hintergründe verstehen. Statistiken, Einordnungen, Interviews und Informationen zu den Mannschaften sollen dabei helfen, sowohl langjährige Rugbyfans als auch neue Interessierte mitzunehmen."
    },
    {
      "type": "paragraph",
      "content": "Für die Interviews und Berichte direkt am Spielfeldrand konnten mit Vivian Bahlmann und Timo Vollenkemper zwei ehemalige Nationalspieler gewonnen werden. Beide sind zudem als Gastgeber des Podcasts „XV Friends presented by Rugby News“ bekannt und werden während der Vorberichterstattung sowie rund um das Spiel Stimmen und Eindrücke vom Finaltag einfangen."
    },
    {
      "type": "paragraph",
      "content": "Am Kommentatorenplatz übernehmen Donal Peoples vom Podcast „Vorpass“ sowie Martin Gerlach, Kommentator der Germania List Streams, die Einordnung des sportlichen Geschehens. Gemeinsam sollen sie die Zuschauer durch das Finale begleiten und gleichzeitig die Besonderheiten des Rugbysports verständlich vermitteln."
    },
    {
      "type": "paragraph",
      "content": "Auch sportlich verspricht die Begegnung höchste Qualität. Mit dem SC 1880 Frankfurt und dem SC Neuenheim treffen zwei der traditionsreichsten Vereine des deutschen Rugbys aufeinander. Entsprechend groß ist das Interesse am Endspiel. Bereits jetzt wurden rund 1.500 der insgesamt etwa 2.000 verfügbaren Tickets verkauft, sodass die Organisatoren mit einer stimmungsvollen Kulisse im Beekestadion rechnen."
    },
    {
      "type": "paragraph",
      "content": "Das Finale wird im Beekestadion Ricklingen am Mühlenholzweg 4b in 30459 Hannover ausgetragen. Weitere Informationen rund um den Finaltag finden Interessierte auf der Website RugbyDM2026.de."
    },
    {
      "type": "paragraph",
      "content": "Wer das Spiel vor Ort erleben möchte, kann über den Ticketverkauf bei Eventim weiterhin Eintrittskarten erwerben."
    },
    {
      "type": "list",
      "items": [
        { "content": "Tickets bei Eventim", "url": "https://www.eventim.de/event/deutsche-rugbymeisterschaft-endspiel-beekestadion-ricklingen-21386798" }
      ],
      "ordered": false
    },
    {
      "type": "paragraph",
      "content": "Der Livestream startet am 13. Juni um 14:15 Uhr auf dem offiziellen YouTube Kanal der Rugby Bundesliga. Der Ankick zum Finale zwischen dem SC 1880 Frankfurt und dem SC Neuenheim erfolgt um 15:00 Uhr."
    },
    {
      "type": "paragraph",
      "content": "Damit beginnt nicht nur das Spiel um die Deutsche Meisterschaft, sondern zugleich ein neues Kapitel in der medialen Entwicklung der Rugby Bundesliga. Das Finale 2026 soll zeigen, wie Rugby in Deutschland künftig präsentiert werden kann: professionell, verständlich und nah an den Menschen, die den Sport Woche für Woche tragen."
    }
  ]
};
